"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var StepConnector = (0, _styles.withStyles)(function (_ref) {
  var palette = _ref.palette;
  return (0, _styles.createStyles)({
    alternativeLabel: {
      top: 9,
      left: 'calc(-50% + 10px)',
      right: 'calc(50% + 10px)'
    },
    active: {
      '& $line': {
        borderColor: palette.secondary.main
      }
    },
    completed: {
      '& $line': {
        borderColor: palette.secondary.main
      }
    },
    line: {
      borderColor: palette.common.white,
      borderTopWidth: 2
    }
  });
})(_material.StepConnector);
var _default = StepConnector;
exports.default = _default;